var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutationenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pensionskassen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechnungen",
    transform: "translate(-31.000000, -435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-Versicherte-Active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mutationen-icon",
    transform: "translate(31.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4586202,5.37006805 C17.8054652,5.73139411 18,6.2190804 18,6.72727273 L18,21.8181818 C18,24 18,24 15.8823529,24 L2.11764706,24 C0.633225605,24 0,23.3475857 0,21.8181818 L0,2.76923077 C0,1.23982685 1.20336135,0 2.68778281,0 L12.0271548,0 C12.527573,0 13.0071894,0.206284792 13.3590782,0.572865249 L17.4586202,5.37006805 Z",
    id: "Path",
    fill: "#AFAFB1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9409671,2 L2.57988166,2 C2.25962186,2 2,2.26786382 2,2.5982906 L2,22 L16,22 L16,20.8888889 L16,6.66666667 L11.9409671,2 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9409671,2 L2.57988166,2 C2.25962186,2 2,2.26786382 2,2.5982906 L2,22 L16,22 L16,20.8888889 L16,6.66666667 L11.9409671,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L12,6 C12,6.55228475 12.4477153,7 13,7 L18,7 L18,7 L12,0 Z",
    id: "Path-3",
    fill: "#AFAFB1"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-2",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12 15 7.87190926 19 6 17.2649629"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-Copy-2",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "12 10 7.87190926 14 6 12.2649629"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutationenIcon);
export default __webpack_public_path__ + "static/media/mutationen_icon.c53dddf5ca37edeb2f3d27a2c3ed6cef.svg";
export { ForwardRef as ReactComponent };